import { get } from "./api.service";

const LocalizationService = {
    getAllCountries() {
        return get("/public/cultures");
    },
};

export { LocalizationService };
